import './About.css'
import { useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import logos from "../img/logos.png"

function About() {
    return (
        <div className="about-main">
            <Container className='about-container'>
                
                    <h1 className='about-title'>What is <b className='blue'>SSHM4Dams</b></h1>
                    <p>Due to climate change, characterized by periods of prolonged drought followed by periods of heavy rainfall,
                        large concrete dams are assuming an increasingly important role in the management of water resources.
                        Being structures with high potential risk , according to ICOLD it is fundamental to ensure the safety of dams for any type
                        of hazards from the natural and man-made environment.
                        <br /><br />
                        In order to verify the structural safety of dams located in seismic areas, it is essential to invest in finite element
                        programs and models for numerical analysis and in monitoring of the dynamic behaviour of dams under ambient/operational
                        vibrations and during seismic events.
                        With that aim, Seismic and Structural Health Monitoring (SSHM) systems must be used,
                        which should be equipped with sensors for continuously measuring vibrations and with appropriate software for automatic
                        analysis of recorded data.
                        <br /><br />
                        The installation of SSHM systems has been proposed for new dams, to evaluate their dynamic behaviour since the
                        first filling of the reservoir, and for some older dams in operation.
                        However, the companies that provide and install these systems cannot present comprehensive software solutions
                        as all dams have unique features, and therefore solutions can only be worked out in close cooperation with dam
                        owners and engineers responsible for safety control.
                        <br /><br />
                        Therefore, the goal of this project is to continue the work that has been developed by the research team in the design and development of SSHM systems.
                    </p>

                    <br /><br />
                    <h3 className='about-subtitle'>Project Specifications</h3>
                    <Col className='project-specs'>
                        <p><b className='blue'>Project Name: </b> Seismic and Structural Health Monitoring of Large Concrete Dams</p>
                        <p><b className='blue'>Activity years: </b> 2021-2024</p>
                        <p><b className='blue'>Funding: </b> Fundação para a Ciência e a Tecnologia, I.P, na sua componente de Orçamento de Estado</p>
                        <p><b className='blue'>Topic: </b>Civil Engineering</p>
                        <p><b className='blue'>Budget: </b> 249 994,03 €</p>
                        <p><b className='blue'>Reference: </b> PTDC/ECI-EGC/5332/2020</p>
                        <p><b className='blue'>Host Institution: </b> Laboratório Nacional de Engenharia Civil (LNEC)</p>
                        <p><b className='blue'>Partners: </b> Instituto Superior de Engenharia de Lisboa (ISEL); Associação do Instituto Superior Técnico para a Investigação e o Desenvolvimento (IST-ID)</p>
                    </Col>

                    <br/><br/>
                    <h3 className='about-subtitle'>Contact Us</h3>
                    <p><b className='blue'>Project Mail: </b>sshm4dams@gmail.com</p>
                    <br /><br />

                    <Row className='logo-row'>
                        <img src={logos} className='logos' />
                    </Row>
                
            </Container>
        </div>
    )
}
export default About;